import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ContractService {
  private urlPrefix: string = environment.appUrl;
  constructor(
    private httpClient: HttpClient
  ) { }

  createServiceContract(customerId, jobId, contractInfo): Observable<any> {
    const url = this.urlPrefix + `service-contract/${customerId}/jobId/${jobId}`;
    return this.httpClient
      .post(url, contractInfo, {
        observe: 'response',
      })
      .map((res: any) => {
        if (res.status === 200 || res.status === 201) {
          return res.body;
        } else {
          return Observable.throw(null);
        }
      })
      .catch(err => {
        return Observable.throw(err);
      });
  }
  deleteContract(contractId): Observable<any> {
    const url = this.urlPrefix + `service-contract/deactive/${contractId}`;
    return this.httpClient
      .delete(url, {
        observe: 'response',
      })
      .map((res: any) => {
        if (res.status === 200 || res.status === 201) {
          return res.body;
        } else {
          return Observable.throw(null);
        }
      })
      .catch(err => {
        return Observable.throw(err);
      });
  }

  getCustomerContractPDF(contractId, customerId) {
    const contractUrl = environment.appUrl + `service-contract/${contractId}/pdf/${customerId}`;

    return this.httpClient.get(contractUrl, {
      responseType: 'blob',
      observe: 'response',
      withCredentials: true
    }).map((res: any) => {
      if (res.status === 200 || res.status === 201) {
        return res.body;
      } else {
        return Observable.throw(null);
      }
    }).catch(err => {
      return Observable.throw(err);
    });

  }

  getSummary(): Observable<any> {
    const url = this.urlPrefix + 'service-contract/list';
    return this.httpClient
      .get(url, {
        observe: 'response',
      })
      .map((res: any) => {
        if (res.status === 200 || res.status === 201) {
          return res.body.contractList;
        } else {
          return Observable.throw(null);
        }
      })
      .catch(err => {
        return Observable.throw(err);
      });
  }

  uploadContractPDF(customerId, jobId, contract): Observable<any> {
    const url = this.urlPrefix + `service-contract/${customerId}/jobId/${jobId}/pdf`;
    return this.httpClient
      .post(url, contract, {
        observe: 'response',
      })
      .map((res: any) => {
        if (res.status === 200) {
          return res.body.contractList;
        } else {
          return Observable.throw(null);
        }
      })
      .catch(err => {
        return Observable.throw(err);
      });
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/contract/contract.service.ts